// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".vue-dat-gui[data-v-092c914f]{z-index:8;top:auto;bottom:10%}.video-container[data-v-092c914f]{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.video-fx[data-v-092c914f]{opacity:0;-webkit-transition:opacity .2s .2s;transition:opacity .2s .2s}.video-fx.visible[data-v-092c914f]{opacity:1}video[data-v-092c914f]{opacity:0;pointer-events:none}", ""]);
// Exports
module.exports = exports;
